(function ($) {
    $(function () {

        $('.js-close-newsletter-modal').on('click', function (e) {
            e.preventDefault();
            $('.js-newsletter-modal, .overlay').removeClass('is-visible');
            $('body').removeClass('body--fixed');
        });



        $('.js-close-press-modal').on('click', function (e) {
            e.preventDefault();
            $('.js-press-modal, .overlay').removeClass('is-visible');
            $('body').removeClass('body--fixed');
        });


        $(document).on('keydown', 'input, textarea', function () {
            $(this)
                .parent('.form-group')
                .removeClass('has-error');
            $(this)
                .next('.error-message')
                .text();
        });

        $(document).on('change', 'input[type="checkbox"], select', function () {
            $(this)
                .parent('.form-group')
                .removeClass('has-error');
        });


        /* Newsletter */
        if ($('.js-newsletter-form').length) {
            $('.js-newsletter-form').submit(function (e) {
                e.preventDefault();
                $('.js-newsletter-submit').attr('disabled', true);
                $('.js-newsletter-loader').removeClass('d-none');

                var theForm = $(this);
                const formData = theForm.serializeArray();

                $.ajax({
                    url: localize.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'newsletter_form',
                        datas: formData
                    },
                    error: function (error) {
                        console.log(error);
                        $('.js-newsletter-submit').removeAttr('disabled');
                        $('.js-newsletter-loader').addClass('d-none');
                    },
                    success: function (data) {
                        var result = JSON.parse(data);
                        var fields = [...new Set(result['fields'])];

                        if (result['status'] == 'success') {

                            if (result['is_subscribed'] == false) {
                                $('.js-newsletter-modal-error').show();
                            } else {
                                theForm.trigger('reset');
                                $('.js-newsletter-modal-success').show();
                            }
                            $('body').addClass('body--fixed');
                            $('.js-newsletter-modal, .overlay').addClass('is-visible');
                        } else {
                            $(fields).each(function (i, e) {
                                theForm
                                    .find(`[name=${e.field}]`)
                                    .parent('.form-group')
                                    .addClass('has-error');
                                theForm
                                    .find(`[name=${e.field}]`)
                                    .next('.error-message')
                                    .text(e.message);
                            });
                        }
                        $('.js-newsletter-loader').addClass('d-none');
                        $('.js-newsletter-submit').removeAttr('disabled');
                    }
                });
            });

        }


        /* Press */
        if ($('.js-press-form').length) {
            $('.js-press-form').submit(function (e) {
                e.preventDefault();
                $('.js-press-submit').attr('disabled', true);
                $('.js-press-loader').removeClass('d-none');
                var theForm = $(this);
                const formData = theForm.serializeArray();

                $.ajax({
                    url: localize.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'press_form',
                        datas: formData
                    },
                    error: function (error) {
                        console.log(error);
                        $('.js-press-submit').removeAttr('disabled');
                        $('.js-press-loader').addClass('d-none');
                    },
                    success: function (data) {
                        var result = JSON.parse(data);
                        var fields = [...new Set(result['fields'])];

                        if (result['status'] == 'success') {

                            if (result['is_subscribed'] == false) {
                                $('.js-press-modal-error').show();
                            } else {
                                theForm.trigger('reset');
                                $('.js-press-modal-success').show();
                            }

                            $('body').addClass('body--fixed');
                            $('.js-press-modal, .overlay').addClass('is-visible');
                        } else {
                            $(fields).each(function (i, e) {
                                theForm
                                    .find(`[name=${e.field}]`)
                                    .parent('.form-group')
                                    .addClass('has-error');
                                theForm
                                    .find(`[name=${e.field}]`)
                                    .next('.error-message')
                                    .text(e.message);
                            });
                        }
                        $('.js-press-loader').addClass('d-none');
                        $('.js-press-submit').removeAttr('disabled');
                    }
                });
            });

        }


        $('.js-scroll-to-newsletter').on('click', function (e) {
            e.preventDefault();

            $('html, body').animate({
                scrollTop: $(".js-newsletter-wrapper").offset().top
            }, 1000);
        });


        const unsubscribeErrorMessages = $('.js-unsubscribe-error');
        const successUnsubscribeMessage = $('.js-success-unsubscribe');

        unsubscribeErrorMessages.add(successUnsubscribeMessage).hide();

        if ($('.js-unsubscribe-newsletter').length || $('.js-unsubscribe-press').length) {

            const parameters = new URLSearchParams(window.location.search);
            const subkey = parameters.get("subKey");
            const form = new FormData();
            var endpoint = "https://cloud.news.szigetfestival.com/gyerek-sziget-unsubscribe";
            if ($('.js-unsubscribe-press').length) {
                endpoint = "https://cloud.news.szigetfestival.com/unsubscribe-press";
            }

            form.append("subKey", subkey);
            form.append("festival", 'GyerekSziget');

            if (!subkey) {
                unsubscribeErrorMessages.show();
                return;
            }

            $.ajax({
                url: endpoint,
                method: "POST",
                mimeType: "multipart/form-data",
                contentType: false,
                processData: false,
                data: form,
            })
                .done(function () {
                    successUnsubscribeMessage.show();
                })
                .fail(function () {
                    unsubscribeErrorMessages.show();
                });
        }

    });
})(jQuery);
